import { DialogsType } from '../types';

const initialState: DialogsType = [];

export default initialState;

